"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformOrganizationMemberRole = void 0;
/**
 * Roles of organization members
 */
var SdPlatformOrganizationMemberRole;
(function (SdPlatformOrganizationMemberRole) {
    /**
     * Suspended organization members are not allowed to login, and
     * are not granted any policies, which organization membership usually grants.
     */
    SdPlatformOrganizationMemberRole["Suspended"] = "suspended";
    /**
     * Organization consumer.
     */
    SdPlatformOrganizationMemberRole["Consumer"] = "consumer";
    /**
     * A plain organization member.
     */
    SdPlatformOrganizationMemberRole["User"] = "user";
    /**
     * Has "owner" permissions for all models of the organization.
     */
    SdPlatformOrganizationMemberRole["Manager"] = "manager";
    /**
     * Allowed to
     * - Add / remove / change role of organization members who are not owners.
     * - Edit settings of organization like visibility, allow_sharing, allow_link_sharing, allow_expose_email.
     * - Manage domains for the organization.
     */
    SdPlatformOrganizationMemberRole["Admin"] = "admin";
    /**
     * Organization owner.
     */
    SdPlatformOrganizationMemberRole["Owner"] = "owner";
})(SdPlatformOrganizationMemberRole = exports.SdPlatformOrganizationMemberRole || (exports.SdPlatformOrganizationMemberRole = {}));
//# sourceMappingURL=SdPlatformOrganizationCommons.js.map